import styled, { useTheme } from "styled-components";
import { FOOT_BAR_HEIGHT } from "../contexts/Constants";
import { useGlobalContext } from "../contexts/Constants";

const Container = styled.div`
  height: ${FOOT_BAR_HEIGHT};
  display: flex;
  justify-content: space-around;
  background-color: white;
  border: 0;
  border-top: 0.03125rem;
  border-color: #d9d9d9;
  border-style: solid;
  & > * {
    font-size: 0.8125rem;
  }
`;
const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1875rem;
  color: ${({ theme }) => theme.primary};
  font-weight: bold;
`;
const Tab = styled.div`
  width: 2.8125rem;
  height: 0.30375rem;
  background-color: ${({ theme }) => theme.primary};
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
`;

const Footbar = () => {
  const { selectedPageState, setSelectedPageState } = useGlobalContext();

  const theme = useTheme();
  return (
    <Container>
      <Page onClick={() => setSelectedPageState("viewAll")}>
        <Tab
          style={{
            background: selectedPageState.startsWith("view")
              ? theme.primary
              : theme.white,
          }}
        />
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.70828 0H1.45828C0.654141 0 0 0.654141 0 1.45828V5.20828C0 6.01258 0.654141 6.66672 1.45828 6.66672H7.70828C8.51258 6.66672 9.16672 6.01258 9.16672 5.20828V1.45828C9.16672 0.654141 8.51258 0 7.70828 0ZM7.70828 8.33328H1.45828C0.654141 8.33328 0 8.98742 0 9.79172V18.5417C0 19.3459 0.654141 20 1.45828 20H7.70828C8.51258 20 9.16672 19.3459 9.16672 18.5417V9.79172C9.16672 8.98742 8.51258 8.33328 7.70828 8.33328ZM18.5417 13.3333H12.2917C11.4874 13.3333 10.8333 13.9874 10.8333 14.7917V18.5417C10.8333 19.3459 11.4874 20 12.2917 20H18.5417C19.3459 20 20 19.3459 20 18.5417V14.7917C20 13.9874 19.3459 13.3333 18.5417 13.3333ZM18.5417 0H12.2917C11.4874 0 10.8333 0.654141 10.8333 1.45828V10.2083C10.8333 11.0126 11.4874 11.6667 12.2917 11.6667H18.5417C19.3459 11.6667 20 11.0126 20 10.2083V1.45828C20 0.654141 19.3459 0 18.5417 0Z"
            fill={
              selectedPageState.startsWith("view")
                ? theme.primary
                : theme.tertiary
            }
          />
        </svg>
        <div
          style={{
            color: selectedPageState.startsWith("view")
              ? theme.primary
              : theme.tertiary,
          }}
        >
          Dashboard
        </div>
      </Page>
      <Page onClick={() => setSelectedPageState("add")}>
        <Tab
          style={{
            background:
              selectedPageState === "add" ? theme.primary : theme.white,
          }}
        />
        <svg
          width="16"
          height="21"
          viewBox="0 0 16 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.9943 2.11986C14.6677 1.78743 14.2333 1.60431 13.7712 1.60431H13.004V2.38556C13.004 3.24712 12.3147 3.94806 11.4673 3.94806H4.55189C3.70451 3.94806 3.01512 3.24712 3.01512 2.38556V1.60431H2.24547C1.29324 1.60431 0.517701 2.39197 0.516624 3.36017L0.500009 18.6727C0.49947 19.1426 0.679086 19.5844 1.00566 19.9169C1.33232 20.2493 1.7667 20.4324 2.22885 20.4324H13.7545C14.7067 20.4324 15.4823 19.6448 15.4834 18.6766L15.5 3.36407C15.5005 2.89419 15.3209 2.45232 14.9943 2.11986ZM8.19593 7.46368H12.2903C12.6085 7.46368 12.8665 7.72603 12.8665 8.04962C12.8665 8.37322 12.6085 8.63556 12.2903 8.63556H8.19593C7.87766 8.63556 7.61966 8.37322 7.61966 8.04962C7.61966 7.72603 7.87766 7.46368 8.19593 7.46368ZM8.19593 11.3699H12.2903C12.6085 11.3699 12.8665 11.6323 12.8665 11.9559C12.8665 12.2795 12.6085 12.5418 12.2903 12.5418H8.19593C7.87766 12.5418 7.61966 12.2795 7.61966 11.9559C7.61966 11.6323 7.87766 11.3699 8.19593 11.3699ZM8.19593 15.2762H12.3067C12.625 15.2762 12.883 15.5385 12.883 15.8621C12.883 16.1857 12.625 16.4481 12.3067 16.4481H8.19593C7.87766 16.4481 7.61966 16.1857 7.61966 15.8621C7.61966 15.5385 7.87766 15.2762 8.19593 15.2762ZM3.28582 7.48681C3.51089 7.25798 3.87574 7.25798 4.10082 7.48681L4.41416 7.80544L5.74316 6.45419C5.96824 6.2254 6.33309 6.22532 6.55812 6.45419C6.78316 6.68298 6.78316 7.054 6.55812 7.28282L4.82162 9.04837C4.76814 9.10278 4.70462 9.14594 4.6347 9.17538C4.56477 9.20483 4.48982 9.21999 4.41412 9.21999C4.33843 9.21999 4.26347 9.20483 4.19355 9.17538C4.12363 9.14594 4.06011 9.10278 4.00662 9.04837L3.28578 8.3154C3.06074 8.08661 3.06074 7.7156 3.28582 7.48681ZM3.28582 11.6914C3.51089 11.4626 3.87574 11.4626 4.10082 11.6914L4.41416 12.01L5.74316 10.6587C5.9682 10.4299 6.33309 10.4299 6.55812 10.6587C6.78316 10.8875 6.78316 11.2585 6.55812 11.4874L4.82162 13.2529C4.76813 13.3073 4.70461 13.3505 4.63469 13.3799C4.56477 13.4094 4.48982 13.4245 4.41412 13.4245C4.33843 13.4245 4.26348 13.4094 4.19356 13.3799C4.12363 13.3505 4.06011 13.3073 4.00662 13.2529L3.28578 12.52C3.06074 12.2912 3.06074 11.9202 3.28582 11.6914ZM3.28582 15.5976C3.51089 15.3688 3.87574 15.3688 4.10082 15.5976L4.41416 15.9162L5.74316 14.565C5.9682 14.3362 6.33309 14.3362 6.55812 14.565C6.78316 14.7938 6.78316 15.1648 6.55812 15.3936L4.82162 17.1592C4.76813 17.2136 4.70461 17.2567 4.63469 17.2862C4.56477 17.3156 4.48982 17.3308 4.41412 17.3308C4.33843 17.3308 4.26348 17.3156 4.19356 17.2862C4.12363 17.2567 4.06011 17.2136 4.00662 17.1592L3.28578 16.4262C3.06074 16.1974 3.06074 15.8265 3.28582 15.5976Z"
            fill={selectedPageState === "add" ? theme.primary : theme.tertiary}
          />
          <path
            d="M4.16775 2.38556C4.16775 2.6013 4.33975 2.77618 4.55194 2.77618H11.4673C11.6795 2.77618 11.8515 2.6013 11.8515 2.38556V0.823059C11.8515 0.607317 11.6795 0.432434 11.4673 0.432434H4.55194C4.33975 0.432434 4.16775 0.607317 4.16775 0.823059V2.38556Z"
            fill={selectedPageState === "add" ? theme.primary : theme.tertiary}
          />
        </svg>
        <div
          style={{
            color: selectedPageState === "add" ? theme.primary : theme.tertiary,
          }}
        >
          Add Pitch
        </div>
      </Page>
      <Page onClick={() => setSelectedPageState("account")}>
        <Tab
          style={{
            background:
              selectedPageState === "account" ? theme.primary : theme.white,
          }}
        />
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.3333 12.4324C15.0948 12.4324 17.3333 10.1939 17.3333 7.43243C17.3333 4.67101 15.0948 2.43243 12.3333 2.43243C9.57192 2.43243 7.33334 4.67101 7.33334 7.43243C7.33334 10.1939 9.57192 12.4324 12.3333 12.4324Z"
            fill={
              selectedPageState === "account" ? theme.primary : theme.tertiary
            }
          />
          <path
            d="M12.3333 14.9324C7.32335 14.9324 3.24335 18.2924 3.24335 22.4324C3.24335 22.7124 3.46335 22.9324 3.74335 22.9324H20.9233C21.2033 22.9324 21.4233 22.7124 21.4233 22.4324C21.4233 18.2924 17.3433 14.9324 12.3333 14.9324Z"
            fill={
              selectedPageState === "account" ? theme.primary : theme.tertiary
            }
          />
        </svg>
        <div
          style={{
            color:
              selectedPageState === "account" ? theme.primary : theme.tertiary,
          }}
        >
          Account
        </div>
      </Page>
    </Container>
  );
};

export default Footbar;
